import React from "react";
import { Link } from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faGithub, faGitlab, faStackOverflow, faLinkedinIn, faTwitter, faInstagram } from "@fortawesome/free-brands-svg-icons"

export default function SocailMedia() {
    return (
        <div className="social-media-div">
            <a href="https://github.com/alvinau0427" className="icon-button -github">
                <FontAwesomeIcon icon={faGithub} />
            </a>

            <Link to="https://gitlab.com/alvinau0427" className="icon-button -gitlab">
                <FontAwesomeIcon icon={faGitlab} />
            </Link>

            <Link to="https://stackoverflow.com/users/13691818/alvinau0427" className="icon-button -stackoverflow">
                <FontAwesomeIcon icon={faStackOverflow} />
            </Link>

            <Link to="https://www.linkedin.com/in/alvinau0427/" className="icon-button -linkedin">
                <FontAwesomeIcon icon={faLinkedinIn} />
            </Link>

            <Link to="https://twitter.com/alvinau0427" className="icon-button -twitter">
                <FontAwesomeIcon icon={faTwitter} />
            </Link>

            <Link to="https://www.instagram.com/alvinau0427/" className="icon-button -instagram">
                <FontAwesomeIcon icon={faInstagram} />
            </Link>
        </div>
    )
}
